import { EMedicalCategoryType } from '@/entities/medical-category';
import { DiagnosisPriceType } from '@/entities/non-benefit';
import { DiagnosisCategoryType } from '@/models/diagnosis';
import { EPharmacyMainTagType, PharmacyVo } from '@/models/pharmacy';
import { EDeprecatedCategoryType } from '@/services/doctor/DiagnosisCategoryService';
import { BOARD_TYPE } from './common';
import { EDiagnosisContactType } from './diagnosis';
import { DiagnosisTypeVo } from './doctor';
import { HospitalDetailModal } from './hospital';
import { EAlternativeType, EDeliveryCategoryType, EPrescriptionSendType } from './pharmacy';
import { EIntegratedSearchTabType } from './search';

export enum DoctornowWebViewType {
  SafeAreaView = 'SafeAreaView',
  BottomSafeAreaView = 'BottomSafeAreaView',
  KeyboardAvoidingView = 'KeyboardAvoidingView',
}

export interface EmergencyContraceptiveScreenProps {
  categoryId: number;
  type: EDeprecatedCategoryType;
}

export interface QnaDetailScreenProps {
  questionPid: string;
  missionId?: string | null;
  result_section?: EIntegratedSearchTabType;
}

export interface HospitalSearchScreenProps {
  latitude?: string;
  longitude?: string;
  keyword?: string;
  sortType?: string;
  mode?: string;
}

export interface MagazineTagListScreenProps {
  tagName: string;
}

export interface HospitalDetailScreenProps {
  hospitalPid: string;
  type?: string;
  modal?: HospitalDetailModal;
  departmentGroupId?: string;
}

export interface MagazineDetailScreenProps {
  magazinePid: string;
}

export interface jumpToHomeScreenWithHomeTabProps {
  isNonFaceToFaceTreatmentRequestClick?: boolean;
}

export interface treatmentRequestAppScreenProps {
  categoryId?: string | string[];
  type: string;
  doctorInfo: {
    id: number;
  };
  userTargetId: number;
  contactType: EDiagnosisContactType;
  pharmacyId?: string;
  treatmentMedicineUnitId?: string | string[];
  dispensationUnit: number;
  treatmentMedicineStrengthId?: string | string[];
  treatmentMedicineId?: string | string[];
}

export interface FamilyRegisterWebViewScreenProps {
  userId?: string;
}

export interface MedicineDictionaryDetailScreenProps {
  medicineDictionaryPid: string;
  keyword: string;
}

export interface DiseaseEncyclopediaDetailScreenProps {
  diseaseEncyclopediaPid: string;
  keyword: string;
}

export interface MagazineAuthorDetailScreenProps {
  authorPublicId: string;
}

export interface QnaTagListScreenProps {
  questionTagId: string;
  tagName: string;
}

export interface QnaListScreenProps {
  categoryId?: string;
}

export interface CommonSearchScreenProps {
  type?: BOARD_TYPE;
  keyword?: string;
}

export interface HomeSearchScreenProps {
  keyword?: string;
  tab?: EIntegratedSearchTabType;
}

export interface PureWebViewAppScreenProps {
  uri: string;
  headerTitle?: string;
}

export interface PharmacyReviewAppScreenProps {
  pharmacyPid: string;
  longitude: number;
  latitude: number;
}

export interface NonBenefitTreatmentMedicineDetailScreenProps {
  treatmentMedicineId: string;
}

export interface KakaoPayWebViewScreenProps {
  url: string;
  transactionId: string;
}

export interface DoctorDetailScreenProps {
  doctorId: string;
  categoryId?: number;
  type: DiagnosisTypeVo | 'vaccination';
  entry: 'search';
  contactType?: EDiagnosisContactType;
  vaccinationTypeId?: string;
  vaccinationUnitId?: string;
  vaccinationFreePolicyId?: string;
}

export interface HospitalEventPageProps {
  eventUrl: string;
  hospitalPid: string;
  type: string;
  departmentGroupId: string;
}

export interface PharmacyDetailScreenProps {
  pharmacyId: string;
  treatmentId?: string;
  longitude?: number;
  latitude?: number;
  diagnosisId?: number;
  alternativeType?: EAlternativeType;
}

export interface DoctorListAppScreenProps {
  type: DiagnosisCategoryType;
  categoryId?: string;
  treatmentMedicineId?: string;
  treatmentMedicineUnitId?: number;
}

export interface PrescriptionSendImageCheckAppScreenProps {
  diagnosisId: number;
  latitude: number;
  longitude: number;
  step: number;
  faxNumber?: string;
  pharmacyId: string;
  tel: string | null;
  location: {
    latitude: number;
    longitude: number;
  };
  preSelectedPharm: PharmacyVo;
}

export interface PointMarketCertificationScreenProps {
  base: 'profile';
}

interface PrescriptionSendProps {
  diagnosisId: string;
  pharmacyId: string;
  longitude?: number;
  latitude?: number;
  step?: number;
}
export type PrescriptionSendFaxInputWebViewScreenProps = PrescriptionSendProps;
export type PrescriptionReselectReasonWebViewScreenProps = PrescriptionSendProps;
export interface PrescriptionSendFaxCheckWebViewScreenProps extends PrescriptionSendProps {
  faxNumber?: string;
}

export interface SearchRequestDetailInfoProps {
  keyword: string;
  categoryId: number | string;
}

export interface PrescriptionFailWebViewScreenProps {
  diagnosisId: number;
  longitude?: number;
  latitude?: number;
}

export interface MedicinePriceInfo {
  medicineId: number;
  medicinePrice: number | null;
  medicineUnit?: number | null;
  prescribedMedicineId?: string;
}
export interface AdditionalOrderWebViewScreenProps {
  prescriptionSendType: EPrescriptionSendType;
  pharmacyId: string;
  diagnosisId: string;
  amountToPay: number | null;
  mainTagTypes?: EPharmacyMainTagType[] | undefined;
  isUserAlternativeSelected?: boolean | null;
  medicineRequestInfos: MedicinePriceInfo[] | null;
}

export interface SelectedScreenWithResetNavigationProps {
  screenName: string;
}

export interface PaymentScreenProps {
  price: number | null;
  immediatePayOrderInfoV2: {
    diagnosisId: string;
    pharmacyId: string;
    amountToPay: number | null;
    medicinePriceInfos: MedicinePriceInfo[];
    deliveryCategoryType: EDeliveryCategoryType;
    mainTagTypes?: string;
    isUserAlternativeSelected?: boolean;
  };
  additionalOrderProducts?: {
    additionalProducts: { productId: string; quantity: number; price: number; name: string }[];
    additionalOrderAmountToPay: number | null;
  };
}

export interface F2FDoctorListAppScreenProps {
  categoryId: string;
  type?: string;
  treatmentMedicineId?: string;
  treatmentMedicineUnitId?: string;
  treatmentMedicineStrengthId?: string;
  priceType?: DiagnosisPriceType;
}

export interface TelemedicineRequestScreenProps {
  type: EMedicalCategoryType;
  categoryId: string;
}

export interface SearchHomeScreenProps {
  keyword: string;
  tab: EIntegratedSearchTabType;
}
